import { SearchResponse } from '@/src/types/flight'
import { encryptQueryString } from '@/src/utils/crypto/encryption'
import setCommonHeaders from '@/src/utils/rtkQuery/setCommonHeaders'
import {
    airlineFilterPriceModifier,
    priceRangeFilterPriceModifier,
    stopsFilterPriceModifier
} from '@/src/utils/srp/RT/filter-price-modier'
import { modifyPricesAndSortOnwardLeg } from '@/src/utils/srp/RT/sort-modifier'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

interface SrpResultsArgs {
    query: string
}

const srpFlightResultsApi = createApi({
    reducerPath: 'srpFlightResultsApi',
    baseQuery: fetchBaseQuery({
        prepareHeaders: headers => {
            headers.set('x-multi-airline', 'true')
            headers.set('x-time-zone', Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone)
            return setCommonHeaders(headers)
        }
    }),
    endpoints: builder => ({
        getSrpResults: builder.query<SearchResponse, SrpResultsArgs>({
            query: ({ query }) => {
                const encryptedData = encryptQueryString(query)
                return `/flight/search/v2/results?data=${encryptedData}`
            },
            transformResponse: (response: SearchResponse) => {
                if (!response) return response
                const isRT = response?.cards?.length === 2
                response.solutionFlowSelectedLeg = 0
                if (isRT) {
                    modifyPricesAndSortOnwardLeg(response)
                    stopsFilterPriceModifier(response, 0)
                    airlineFilterPriceModifier(response, 0)
                    priceRangeFilterPriceModifier(response, 0)
                }

                return response
            }
        })
    })
})

export const { useGetSrpResultsQuery, useLazyGetSrpResultsQuery } = srpFlightResultsApi
export default srpFlightResultsApi
